<template>
  <div>
    <task-type v-model="type"></task-type>
    <div class="all-task-offers">
      <task-card v-for="(task, index) in tasks" :key="index" :task="task" @getType="getType"/>
    </div>
    <div style="text-align:center;">
      <pagination :data="paginationData" @pagination-change-page="getResults"></pagination>
    </div>
  </div>
</template>

<script>
  import TaskType from "./TaskType";
  import TaskCard from "./TaskCard";

  export default {
    components: {TaskCard, TaskType},
    created() {
      let taskUpdateCallback = event => {
        console.log(event)
        window.ev = event
        _.forEach(this.tasks, (task, index) => {
          if (task.id === event.detail.id) {
            _.forEach(event.detail, (value, key) => {
              this.$set(this.tasks[index], key, value)
            })
          }
        })
      }

      document.addEventListener('task-updated', taskUpdateCallback)
      this.$on('hook:beforeDestroy', () => document.removeEventListener('task-updated', taskUpdateCallback))
    },
    data() {
      return {
        type: "all",
        tasks: [],
        paginationData: {}
      };
    },
    methods: {
      getType: function (type) {
        this.type = type;
      },
      getResults: function (page = 1) {
        this.getTasks(this.type, page);
      },
      getTasks(type = "all", page = 1) {
        let urls = {
          all: "/dashboard/task",
          todo: "/dashboard/task/todo",
          done: "/dashboard/task/done",
          inprogress: "/dashboard/task/inprogress"
        };
        this.$Progress.start();
        let self = this;
        axios({
          method: "get",
          url: urls[type] + "?page=" + page
        })
          .then(function (res) {
            if (res.data.ok) {
              self.$Progress.finish();
              self.tasks = res.data.tasks.data;
              self.paginationData = res.data.tasks;
            } else {
              self.$Progress.fail();
            }
          })
          .catch(function (err) {
            self.$Progress.fail();
            console.log(err);
          });
      }
    },
    watch: {
      type: {
        immediate: true,
        handler() {
          this.getResults(1);
        }
      }
    }
  };
</script>
<style>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }
</style>
